import React, { Component } from "react";
import cx from "classnames";
import {
  FeedIcon,
  AppsIcon,
  AppIcon,
  WhiteboardIcon,
  OperatorIcon,
  EmailIcon,
  ClockIcon,
  FlowerIcon,
  GearsIcon,
  MyTeamIcon,
} from "./Icons";
import "./Sidebar.css";

class Sidebar extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  open = () => {
    this.setState({
      open: true,
    });
  };

  close = () => {
    this.setState({
      open: false,
      appsOpen: false,
    });
    this.props.onClose && this.props.onClose();
  };

  select = () => {
    this.props.onSelect && this.props.onSelect();
  };

  toggleApps = (e) => {
    e.stopPropagation();
    this.setState({
      appsOpen: !this.state.appsOpen,
    });
  };

  render() {
    const { name, children, isLineManager } = this.props;
    const open = this.state.open || this.props.open;
    const appsOpen = open && this.state.appsOpen;

    return (
      <div data-testid="sidebar" className={cx("Sidebar", { "Sidebar--Open": open })}>
        <div className="Sidebar__Overlay" onClick={this.close} />
        <div
          className="Sidebar__Navigation"
          onMouseEnter={this.open}
          onMouseOver={this.open}
          onMouseLeave={this.close}
          onClick={this.select}
        >
          <SidebarItem href="/" icon={<FeedIcon />}>
            {name}
          </SidebarItem>
          <SidebarItem icon={<AppsIcon />} onClick={this.toggleApps}>
            Apps
          </SidebarItem>
          <SidebarApps open={appsOpen} />
          {children({ close: this.close })}
          {isLineManager && <SidebarItem icon={<MyTeamIcon />} href="/team">My Team</SidebarItem>}
        </div>
        <div className="Sidebar__Hamburger" onClick={this.open}>
          <FeedIcon />
        </div>
      </div>
    );
  }
}

const SidebarItem = ({ icon, to, href, onClick, title, children }) => {
  const item = (
    <div className="Sidebar__Item" onClick={onClick} title={title}>
      <div className="Sidebar__Item__Icon">{icon}</div>
      <span className="Sidebar__Item__Title">{children}</span>
    </div>
  );

  if (href) {
    return <a href={href}>{item}</a>;
  } else {
    return item;
  }
};

const SidebarDivider = () => <div className="Sidebar__Divider" />;
const SidebarSpacer = () => <div className="Sidebar__Spacer" />;

const SidebarApps = ({ open }) => (
  <div className={cx("Sidebar__Apps", { "Sidebar__Apps--Open": open })}>
    <SidebarItem
      href="https://native.feed.xyz"
      icon={<WhiteboardIcon />}
      children="Native"
    />
    <SidebarItem
      href="https://operator.feed.xyz"
      icon={<OperatorIcon />}
      children="Operator"
    />
    <SidebarItem
      href="https://mercury.feed.xyz/"
      icon={<EmailIcon />}
      children="Mercury"
    />
    <SidebarItem
      href={"https://research-tool.feed.xyz/"}
      icon={<FlowerIcon />}
      children="Polinate"
    />
    <SidebarItem
      href={"https://brand-audit-tool.feed.xyz/"}
      icon={<AppIcon />}
      children="Brand Audit Tool"
    />
    <SidebarItem
      href={"https://timesheets.feed.xyz/"}
      icon={<ClockIcon />}
      children="Timesheets"
    />
    <SidebarItem
      href={"http://max.feed.xyz/"}
      icon={<GearsIcon />}
      children="MAX"
    />
  </div>
);

const SidebarSecondary = ({ children, onClose }) => (
  <div className="Sidebar__Secondary">
    <div className="Sidebar__Secondary__Overlay" onClick={onClose} />
    <div className="Sidebar__Secondary__Content" children={children} />
  </div>
);
export {
  Sidebar,
  SidebarSecondary,
  SidebarItem,
  SidebarDivider,
  SidebarSpacer,
};
